// ═══════════════════════════════════════════════════════════════
// RAAGENGINE EXPERT DATA — COMPREHENSIVE GLOBAL EDITION
// Instruments: 200+ across 30+ traditions
// Scales/Ragas/Maqam: 150+ across 15+ traditions
// ═══════════════════════════════════════════════════════════════

// ── SCALE GROUPS ─────────────────────────────────────────────
export const SCALE_GROUPS = [

  // ── WESTERN MODES ────────────────────────────────────────
  { label: '🎸 Western Modes', options: [
    { v: 'Major (Happy, Bright, Pop)', l: 'Major (Happy, Bright, Pop)' },
    { v: 'Natural Minor (Sad, Dark, Emotional)', l: 'Natural Minor (Sad, Dark, Emotional)' },
    { v: 'Dorian (Cool, Jazz, Lo-Fi)', l: 'Dorian (Cool, Jazz, Lo-Fi)' },
    { v: 'Pentatonic Minor (Blues, Rock, Hip-Hop)', l: 'Pentatonic Minor (Blues, Rock, Hip-Hop)' },
    { v: 'Pentatonic Major (Folk, World, Bright)', l: 'Pentatonic Major (Folk, World, Bright)' },
    { v: 'Phrygian (Dark, Flamenco, Metal)', l: 'Phrygian (Dark, Flamenco, Metal)' },
    { v: 'Lydian (Dreamy, Cinematic, Floating)', l: 'Lydian (Dreamy, Cinematic, Floating)' },
    { v: 'Mixolydian (Celtic, Classic Rock, Warm)', l: 'Mixolydian (Celtic, Classic Rock, Warm)' },
    { v: 'Locrian (Dissonant, Avant-garde)', l: 'Locrian (Dissonant, Avant-garde)' },
    { v: 'Harmonic Minor (Dramatic, Arabic-ish, Intense)', l: 'Harmonic Minor (Dramatic, Arabic-ish, Intense)' },
    { v: 'Melodic Minor (Jazz, Sophisticated)', l: 'Melodic Minor (Jazz, Sophisticated)' },
    { v: 'Blues Scale (Blues, Soul, Gritty)', l: 'Blues Scale (Blues, Soul, Gritty)' },
    { v: 'Whole Tone (Dreamy, Impressionist, Floating)', l: 'Whole Tone (Dreamy, Impressionist, Floating)' },
    { v: 'Diminished (Tense, Horror, Suspense)', l: 'Diminished (Tense, Horror, Suspense)' },
    { v: 'Augmented Scale (Otherworldly, Sci-fi)', l: 'Augmented Scale (Otherworldly, Sci-fi)' },
    { v: 'Double Harmonic (Exotic, Byzantine, Dark)', l: 'Double Harmonic / Byzantine (Exotic, Dark)' },
    { v: 'Hungarian Minor (Gypsy, Dark, Dramatic)', l: 'Hungarian Minor (Gypsy, Dark, Dramatic)' },
    { v: 'Neapolitan Major (Rich, Baroque)', l: 'Neapolitan Major (Rich, Baroque)' },
    { v: 'Neapolitan Minor (Dark, Operatic)', l: 'Neapolitan Minor (Dark, Operatic)' },
    { v: 'Prometheus Scale (Scriabin, Mystical)', l: 'Prometheus Scale (Scriabin, Mystical)' },
  ]},

  // ── JAZZ ─────────────────────────────────────────────────
  { label: '🎷 Jazz Scales', options: [
    { v: 'Dorian (Smooth Jazz, Cool)', l: 'Dorian (Smooth Jazz, Cool)' },
    { v: 'Lydian Dominant (Jazz-Funk, Fusion)', l: 'Lydian Dominant (Jazz-Funk, Fusion)' },
    { v: 'Altered Scale (Jazz, Tension)', l: 'Altered Scale (Jazz, Tension/Resolution)' },
    { v: 'Blues Scale (Blues, Jazz)', l: 'Blues Scale (Blues, Jazz)' },
    { v: 'Bebop Dominant (Swing, Bebop)', l: 'Bebop Dominant (Swing, Bebop)' },
    { v: 'Melodic Minor Jazz (Sophisticated)', l: 'Melodic Minor Jazz (Sophisticated)' },
    { v: 'Whole Tone (Impressionistic Jazz)', l: 'Whole Tone (Impressionistic Jazz)' },
    { v: 'Half-Whole Diminished (Tension, Bop)', l: 'Half-Whole Diminished (Tension, Bop)' },
  ]},

  // ── ELECTRONIC / LO-FI ───────────────────────────────────
  { label: '🎧 Electronic / Lo-Fi / Hip-Hop', options: [
    { v: 'Pentatonic Minor (Trap, Lo-Fi)', l: 'Pentatonic Minor (Trap, Lo-Fi)' },
    { v: 'Dorian (Lo-Fi, Chillhop)', l: 'Dorian (Lo-Fi, Chillhop)' },
    { v: 'Natural Minor (Dark Trap, Emo)', l: 'Natural Minor (Dark Trap, Emo)' },
    { v: 'Lydian (Future Bass, Uplifting)', l: 'Lydian (Future Bass, Uplifting)' },
    { v: 'Phrygian (Dark EDM, Hard Techno)', l: 'Phrygian (Dark EDM, Hard Techno)' },
    { v: 'Lydian Dominant (Funk, Electronic Fusion)', l: 'Lydian Dominant (Funk, Electronic Fusion)' },
  ]},

  // ── CINEMATIC ────────────────────────────────────────────
  { label: '🎬 Cinematic / Orchestral', options: [
    { v: 'Harmonic Minor (Epic, Villain)', l: 'Harmonic Minor (Epic, Villain)' },
    { v: 'Natural Minor (Sad Cinematic, Drama)', l: 'Natural Minor (Sad Cinematic, Drama)' },
    { v: 'Lydian (Wonder, Hans Zimmer style)', l: 'Lydian (Wonder, Hans Zimmer style)' },
    { v: 'Phrygian (Dark Cinematic, Tension)', l: 'Phrygian (Dark Cinematic, Tension)' },
    { v: 'Major (Heroic, Triumph, Adventure)', l: 'Major (Heroic, Triumph, Adventure)' },
    { v: 'Whole Tone (Dream Sequence, Surreal)', l: 'Whole Tone (Dream Sequence, Surreal)' },
    { v: 'Diminished (Horror, Suspense)', l: 'Diminished (Horror, Suspense)' },
    { v: 'Double Harmonic (Epic Clash, Ancient Battle)', l: 'Double Harmonic (Epic Clash, Ancient Battle)' },
  ]},

  // ── CELTIC / FOLK / WORLD ────────────────────────────────
  { label: '🍀 Celtic / Folk / World', options: [
    { v: 'Mixolydian (Celtic, Irish Folk)', l: 'Mixolydian (Celtic, Irish Folk)' },
    { v: 'Dorian (Scottish, Dark Folk)', l: 'Dorian (Scottish, Dark Folk)' },
    { v: 'Pentatonic Major (Folk, African)', l: 'Pentatonic Major (Folk, African)' },
    { v: 'Phrygian (Spanish, Flamenco)', l: 'Phrygian (Spanish, Flamenco)' },
    { v: 'Major Scale (Bluegrass, Country)', l: 'Major Scale (Bluegrass, Country)' },
    { v: 'Freygish / Ahava Raba (Klezmer, Jewish)', l: 'Freygish / Ahava Raba (Klezmer, Jewish)' },
    { v: 'Ukrainian Dorian (Eastern European Folk)', l: 'Ukrainian Dorian (Eastern European Folk)' },
  ]},

  // ── HINDUSTANI — MORNING ─────────────────────────────────
  { label: '🏮 Indian — Hindustani (Morning)', options: [
    { v: 'Bhairav (Deep Dawn, Solemn)', l: 'Bhairav (Deep Dawn, Solemn)' },
    { v: 'Ahir Bhairav (Peaceful Dawn)', l: 'Ahir Bhairav (Peaceful Dawn)' },
    { v: 'Lalit (Pre-Dawn, Mysterious)', l: 'Lalit (Pre-Dawn, Mysterious)' },
    { v: 'Todi (Morning, Intense Focus)', l: 'Todi (Morning, Intense Focus)' },
    { v: 'Gujari Todi (Morning Devotion)', l: 'Gujari Todi (Morning Devotion)' },
    { v: 'Ramkali (Morning, Spiritual)', l: 'Ramkali (Morning, Spiritual)' },
    { v: 'Vibhas (Very Early Morning)', l: 'Vibhas (Very Early Morning)' },
    { v: 'Komal Rishabh Asavari (Early Morning, Meditative)', l: 'Komal Rishabh Asavari (Early Morning)' },
  ]},

  // ── HINDUSTANI — DAY ─────────────────────────────────────
  { label: '🏮 Indian — Hindustani (Day)', options: [
    { v: 'Saraswati (Knowledge, Clarity)', l: 'Saraswati (Knowledge, Clarity)' },
    { v: 'Bhimpalasi (Afternoon, Longing)', l: 'Bhimpalasi (Afternoon, Longing)' },
    { v: 'Multani (Afternoon, Deep)', l: 'Multani (Afternoon, Deep)' },
    { v: 'Madhuvanti (Afternoon, Sweet)', l: 'Madhuvanti (Afternoon, Sweet)' },
    { v: 'Nat Bhairav (Midday Energy)', l: 'Nat Bhairav (Midday Energy)' },
    { v: 'Patdeep (Afternoon, Tender)', l: 'Patdeep (Afternoon, Tender)' },
    { v: 'Barwa (Midday, Powerful)', l: 'Barwa (Midday, Powerful)' },
  ]},

  // ── HINDUSTANI — EVENING ─────────────────────────────────
  { label: '🌅 Indian — Hindustani (Evening)', options: [
    { v: 'Yaman (Evening, Majestic)', l: 'Yaman (Evening, Majestic)' },
    { v: 'Yaman Kalyan (Evening, Serene)', l: 'Yaman Kalyan (Evening, Serene)' },
    { v: 'Puriya (Twilight, Romantic)', l: 'Puriya (Twilight, Romantic)' },
    { v: 'Puriya Dhanashri (Evening, Yearning)', l: 'Puriya Dhanashri (Evening, Yearning)' },
    { v: 'Marwa (Pre-Sunset, Tense/Focus)', l: 'Marwa (Pre-Sunset, Tense/Focus)' },
    { v: 'Shree (Sunset, Devotional)', l: 'Shree (Sunset, Devotional)' },
    { v: 'Bihag (Evening, Romantic Longing)', l: 'Bihag (Evening, Romantic Longing)' },
    { v: 'Kedar (Evening, Devotional Calm)', l: 'Kedar (Evening, Devotional Calm)' },
  ]},

  // ── HINDUSTANI — NIGHT ───────────────────────────────────
  { label: '🌙 Indian — Hindustani (Night)', options: [
    { v: 'Darbari Kanada (Night, Regal)', l: 'Darbari Kanada (Night, Regal)' },
    { v: 'Bageshri (Night, Romantic)', l: 'Bageshri (Night, Romantic)' },
    { v: 'Jaunpuri (Night, Melancholic)', l: 'Jaunpuri (Night, Melancholic)' },
    { v: 'Bhairavi (Late Night, Universal Peace)', l: 'Bhairavi (Late Night, Universal Peace)' },
    { v: 'Malkauns (Midnight, Powerful)', l: 'Malkauns (Midnight, Powerful)' },
    { v: 'Chandrakauns (Midnight, Mysterious)', l: 'Chandrakauns (Midnight, Mysterious)' },
    { v: 'Charukeshi (Night, Tender)', l: 'Charukeshi (Night, Tender)' },
    { v: 'Adana (Night, Intense)', l: 'Adana (Night, Intense)' },
    { v: 'Nand (Night, Joyful)', l: 'Nand (Night, Joyful)' },
  ]},

  // ── HINDUSTANI — EMOTIONAL / SEASONAL ───────────────────
  { label: '🎭 Indian — Hindustani (Emotional)', options: [
    { v: 'Shivaranjani (Soulful, Bittersweet)', l: 'Shivaranjani (Soulful, Bittersweet)' },
    { v: 'Kirwani (Universal, Emotional)', l: 'Kirwani (Universal, Emotional)' },
    { v: 'Durga (Victorious, Powerful)', l: 'Durga (Victorious, Powerful)' },
    { v: 'Hamsadhwani (Celebration, Joy)', l: 'Hamsadhwani (Celebration, Joy)' },
    { v: 'Bilaval (Pure Joy, Brightness)', l: 'Bilaval (Pure Joy, Brightness)' },
    { v: 'Miyan Malhar (Monsoon, Longing)', l: 'Miyan Malhar (Monsoon, Longing)' },
    { v: 'Desh (Patriotic, Nostalgic)', l: 'Desh (Patriotic, Nostalgic)' },
    { v: 'Basant (Spring, Celebration)', l: 'Basant (Spring, Celebration)' },
    { v: 'Bahar (Spring Blossoming, Joyful)', l: 'Bahar (Spring Blossoming, Joyful)' },
    { v: 'Megh (Monsoon, Yearning)', l: 'Megh (Monsoon, Yearning)' },
    { v: 'Bhoop (Open, Serene, Pentatonic)', l: 'Bhoop (Open, Serene, Pentatonic)' },
    { v: 'Gorakh Kalyan (Mystical, Meditative)', l: 'Gorakh Kalyan (Mystical, Meditative)' },
    { v: 'Shuddh Sarang (Noon Longing)', l: 'Shuddh Sarang (Noon Longing)' },
  ]},

  // ── CARNATIC ─────────────────────────────────────────────
  { label: '🎶 Carnatic Ragas', options: [
    { v: 'Shankarabharanam (Carnatic Major, Bright)', l: 'Shankarabharanam (Carnatic Major, Bright)' },
    { v: 'Kalyani (Carnatic Lydian, Elevated)', l: 'Kalyani (Carnatic Lydian, Elevated)' },
    { v: 'Kharaharapriya (Carnatic Dorian, Emotional)', l: 'Kharaharapriya (Carnatic Dorian)' },
    { v: 'Mayamalavagowla (Devotional, Ancient)', l: 'Mayamalavagowla (Devotional, Ancient)' },
    { v: 'Natabhairavi (Deep, Melancholic)', l: 'Natabhairavi (Deep, Melancholic)' },
    { v: 'Kamavardhini (Intense, Rare)', l: 'Kamavardhini / Pantuvarali (Intense)' },
    { v: 'Hamsadhwani Carnatic (Celebration, Joy)', l: 'Hamsadhwani Carnatic (Celebration, Joy)' },
    { v: 'Mohanam (Pentatonic, Serene)', l: 'Mohanam (Pentatonic, Serene)' },
    { v: 'Hindolam (Carnatic, Devotional)', l: 'Hindolam (Carnatic, Devotional)' },
    { v: 'Varali (Ancient, Mysterious)', l: 'Varali (Ancient, Mysterious)' },
    { v: 'Arabhi (Heroic, Devotional)', l: 'Arabhi (Heroic, Devotional)' },
    { v: 'Todi Carnatic (Intense, Morning)', l: 'Todi Carnatic (Intense, Morning)' },
    { v: 'Raag Kafi (spring, devotional)', l: 'Raag Kafi (Spring, Devotional)' },
    { v: 'Raag Jhinjhoti (tender bhakti)', l: 'Raag Jhinjhoti (Tender Bhakti)' },
    { v: 'Raag Bhoopali (open, serene)', l: 'Raag Bhoopali (Open, Serene)' },
  ]},

  // ── PERSIAN / IRANIAN DASTGAH ────────────────────────────
  { label: '🌙 Persian / Iranian Dastgah', options: [
    { v: 'Shur (Persian, Longing, Most Common)', l: 'Shur (Longing, Most Common)' },
    { v: 'Homayoun (Persian, Dark, Spiritual)', l: 'Homayoun (Dark, Spiritual)' },
    { v: 'Chahargah (Persian, Powerful, Dramatic)', l: 'Chahargah (Powerful, Dramatic)' },
    { v: 'Segah (Persian, Tender, Melancholic)', l: 'Segah (Tender, Melancholic)' },
    { v: 'Bayat-e-Tork (Persian, Bittersweet)', l: 'Bayat-e-Tork (Bittersweet, Wistful)' },
    { v: 'Dashti (Persian, Nostalgic, Regional)', l: 'Dashti (Nostalgic, Regional)' },
    { v: 'Isfahan (Persian, Refined, Noble)', l: 'Isfahan (Refined, Noble)' },
    { v: 'Abu Ata (Persian, Plaintive, Folk)', l: 'Abu Ata (Plaintive, Folk)' },
    { v: 'Nava (Persian, Gentle, Spiritual)', l: 'Nava (Gentle, Spiritual)' },
    { v: 'Rast-Panjgah (Persian, Bright, Balanced)', l: 'Rast-Panjgah (Bright, Balanced)' },
  ]},

  // ── ARABIC / TURKISH MAQAM ───────────────────────────────
  { label: '🌙 Arabic / Turkish Maqam', options: [
    { v: 'Maqam Rast (Arabic, Balanced, Spiritual)', l: 'Maqam Rast (Balanced, Spiritual)' },
    { v: 'Maqam Bayati (Arabic, Emotional, Soul)', l: 'Maqam Bayati (Emotional, Soul)' },
    { v: 'Maqam Hijaz (Arabic, Desert, Exotic)', l: 'Maqam Hijaz (Desert, Exotic)' },
    { v: 'Maqam Kurd (Arabic, Dark, Introspective)', l: 'Maqam Kurd (Dark, Introspective)' },
    { v: 'Maqam Nahawand (Arabic, Minor, Romantic)', l: 'Maqam Nahawand (Romantic, Minor)' },
    { v: 'Maqam Saba (Arabic, Plaintive, Grief)', l: 'Maqam Saba (Plaintive, Grief)' },
    { v: 'Maqam Ajam (Arabic, Major, Bright)', l: 'Maqam Ajam (Major, Bright)' },
    { v: 'Makam Uşşak (Turkish, Tender, Longing)', l: 'Makam Uşşak (Turkish, Tender, Longing)' },
    { v: 'Makam Hicaz (Turkish, Exotic, Sacred)', l: 'Makam Hicaz (Turkish, Exotic, Sacred)' },
    { v: 'Makam Nihavend (Turkish, Romantic, Minor)', l: 'Makam Nihavend (Turkish, Romantic)' },
    { v: 'Makam Saba (Turkish, Deep Sorrow)', l: 'Makam Saba (Turkish, Deep Sorrow)' },
  ]},

  // ── EAST ASIAN ───────────────────────────────────────────
  { label: '🎋 East Asian Scales', options: [
    { v: 'Hirajoshi (Japanese, Wabi-Sabi)', l: 'Hirajoshi (Japanese, Wabi-Sabi)' },
    { v: 'Ryukyu Scale (Okinawa, Festive)', l: 'Ryukyu Scale (Okinawa, Festive)' },
    { v: 'Iwato Scale (Zen, Ancient)', l: 'Iwato Scale (Zen, Ancient)' },
    { v: 'Yo Scale (Japanese, Bright Folk)', l: 'Yo Scale (Japanese, Bright Folk)' },
    { v: 'In Scale (Japanese, Dark, Introspective)', l: 'In Scale (Japanese, Dark)' },
    { v: 'Akebono Scale (Japanese, Dawn)', l: 'Akebono Scale (Japanese, Dawn)' },
    { v: 'Chinese Pentatonic (Ancient, Regal)', l: 'Chinese Pentatonic (Ancient, Regal)' },
    { v: 'Gong Mode (Chinese, Stable, Earth)', l: 'Gong Mode (Chinese, Stable, Earth)' },
    { v: 'Zhi Mode (Chinese, Lively, Fire)', l: 'Zhi Mode (Chinese, Lively, Fire)' },
    { v: 'Gyeonggi Folk Scale (Korean, Bright)', l: 'Gyeonggi Folk Scale (Korean, Bright)' },
  ]},

  // ── SOUTH EAST ASIAN ─────────────────────────────────────
  { label: '🌴 South East Asian Scales', options: [
    { v: 'Pelog (Balinese Gamelan, Sacred, Ceremonial)', l: 'Pelog (Balinese Gamelan, Sacred)' },
    { v: 'Slendro (Javanese Gamelan, Meditative)', l: 'Slendro (Javanese Gamelan, Meditative)' },
    { v: 'Thai Pentatonic (Classical Thai, Ceremonial)', l: 'Thai Pentatonic (Classical Thai)' },
    { v: 'Kulintang Scale (Philippine, Festive)', l: 'Kulintang Scale (Philippine, Festive)' },
  ]},

  // ── AFRICAN ──────────────────────────────────────────────
  { label: '🌍 African Scales', options: [
    { v: 'West African Pentatonic (Griot, Ancestral)', l: 'West African Pentatonic (Griot, Ancestral)' },
    { v: 'Afrobeat Scale (Lagos, Rhythmic, Dance)', l: 'Afrobeat Scale (Rhythmic, Dance)' },
    { v: 'Ethiopian Tizita (Nostalgic, Longing)', l: 'Ethiopian Tizita (Nostalgic, Longing)' },
    { v: 'Ethiopian Bati (Joyful, Festive)', l: 'Ethiopian Bati (Joyful, Festive)' },
    { v: 'Mbira Pentatonic (Zimbabwean, Ancestral)', l: 'Mbira Pentatonic (Zimbabwean, Ancestral)' },
    { v: 'Algerian Scale (North African, Desert)', l: 'Algerian Scale (North African, Desert)' },
  ]},

  // ── CENTRAL ASIAN ────────────────────────────────────────
  { label: '🏔 Central Asian Scales', options: [
    { v: 'Doira Makam (Uzbek, Ceremonial)', l: 'Doira Makam (Uzbek, Ceremonial)' },
    { v: 'Shashmaqam (Tajik/Uzbek, Classical)', l: 'Shashmaqam (Tajik/Uzbek, Classical)' },
    { v: 'Kazakh Steppe Scale (Open, Vast)', l: 'Kazakh Steppe Scale (Open, Vast)' },
    { v: 'Mongolian Pentatonic (Open Plains, Epic)', l: 'Mongolian Pentatonic (Open Plains, Epic)' },
  ]},

  // ── EXPERIMENTAL / SPECIAL ───────────────────────────────
  { label: '🔬 Experimental / Special', options: [
    { v: 'Microtonal (Quarter-Tone, Between Notes)', l: 'Microtonal (Quarter-Tone, Between Notes)' },
    { v: 'Spectral Harmony (Overtone Series, Sci-fi)', l: 'Spectral Harmony (Overtone Series)' },
    { v: 'Octatonic / Symmetric Diminished (Tension)', l: 'Octatonic / Symmetric Diminished' },
    { v: 'Just Intonation (Pure Tuning, Ancient)', l: 'Just Intonation (Pure Tuning, Ancient)' },
    { v: '432Hz Natural Tuning (Warm, Organic)', l: '432Hz Natural Tuning (Warm, Organic)' },
  ]},
];

// ── INSTRUMENTS ──────────────────────────────────────────────
export const INSTS: Array<{ g: string; v: string; n: string }> = [

  // ── SOUTH ASIAN — WIND ───────────────────────────────────
  { g: '🪈 South Asian — Wind', v: 'Bansuri weaving melodic phrases', n: 'Bansuri' },
  { g: '🪈 South Asian — Wind', v: 'Shehnai ceremonial lead melody', n: 'Shehnai' },
  { g: '🪈 South Asian — Wind', v: 'Murali Flute devotional melody', n: 'Murali Flute' },
  { g: '🪈 South Asian — Wind', v: 'Pungi snake charmer drone melody', n: 'Pungi' },
  { g: '🪈 South Asian — Wind', v: 'Nadaswaram South Indian ceremonial wind', n: 'Nadaswaram' },
  { g: '🪈 South Asian — Wind', v: 'Algoza twin flute folk melody', n: 'Algoza' },
  { g: '🪈 South Asian — Wind', v: 'Satara twin Rajasthani flute', n: 'Satara' },

  // ── SOUTH ASIAN — STRINGS ────────────────────────────────
  { g: '🎸 South Asian — Strings', v: 'Sitar playing intricate melodic phrases', n: 'Sitar' },
  { g: '🎸 South Asian — Strings', v: 'Sarod performing deep melodic lines', n: 'Sarod' },
  { g: '🎸 South Asian — Strings', v: 'Veena lead melody', n: 'Veena' },
  { g: '🎸 South Asian — Strings', v: 'Santoor hammered dulcimer melody', n: 'Santoor' },
  { g: '🎸 South Asian — Strings', v: 'Sarangi bowed string melody', n: 'Sarangi' },
  { g: '🎸 South Asian — Strings', v: 'Esraj bowed string lead melody', n: 'Esraj' },
  { g: '🎸 South Asian — Strings', v: 'Dilruba bowed string lead', n: 'Dilruba' },
  { g: '🎸 South Asian — Strings', v: 'Rudra Veena ancient deep string melody', n: 'Rudra Veena' },
  { g: '🎸 South Asian — Strings', v: 'Surbahar bass sitar deep melody', n: 'Surbahar' },
  { g: '🎸 South Asian — Strings', v: 'Swarmandal Indian autoharp strummed', n: 'Swarmandal' },
  { g: '🎸 South Asian — Strings', v: 'Dotara rural Bengali two-string melody', n: 'Dotara' },
  { g: '🎸 South Asian — Strings', v: 'Ravanahatha ancient bowed string drone', n: 'Ravanahatha' },
  { g: '🎸 South Asian — Strings', v: 'Kamaicha Rajasthani bowed string', n: 'Kamaicha' },
  { g: '🎸 South Asian — Strings', v: 'Gopichand / Ektara single-string drone melody', n: 'Ektara / Gopichand' },
  { g: '🎸 South Asian — Strings', v: 'Pena Manipuri bowed string', n: 'Pena' },

  // ── SOUTH ASIAN — RHYTHM ─────────────────────────────────
  { g: '🥁 South Asian — Rhythm', v: 'Tabla keeping rhythmic cycles', n: 'Tabla' },
  { g: '🥁 South Asian — Rhythm', v: 'Pakhawaj deep barrel drum rhythm', n: 'Pakhawaj' },
  { g: '🥁 South Asian — Rhythm', v: 'Mridangam South Indian percussion', n: 'Mridangam' },
  { g: '🥁 South Asian — Rhythm', v: 'Dholak folk double-headed drum', n: 'Dholak' },
  { g: '🥁 South Asian — Rhythm', v: 'Kanjira South Indian frame drum', n: 'Kanjira' },
  { g: '🥁 South Asian — Rhythm', v: 'Ghatam clay pot percussion', n: 'Ghatam' },
  { g: '🥁 South Asian — Rhythm', v: 'Thavil South Indian barrel drum', n: 'Thavil' },
  { g: '🥁 South Asian — Rhythm', v: 'Chenda South Indian cylinder drum', n: 'Chenda' },
  { g: '🥁 South Asian — Rhythm', v: 'Nagara large kettledrum ceremonial', n: 'Nagara' },
  { g: '🥁 South Asian — Rhythm', v: 'Damru small two-headed Shiva drum', n: 'Damru' },
  { g: '🥁 South Asian — Rhythm', v: 'Khol East Indian elongated drum', n: 'Khol' },
  { g: '🥁 South Asian — Rhythm', v: 'Daf large Persian frame drum', n: 'Daf' },

  // ── SOUTH ASIAN — DRONE / KEYBOARD ──────────────────────
  { g: '🎵 South Asian — Drone & Keys', v: 'Tanpura drone sustain', n: 'Tanpura' },
  { g: '🎵 South Asian — Drone & Keys', v: 'Shruti Box harmonium drone', n: 'Shruti Box' },
  { g: '🎵 South Asian — Drone & Keys', v: 'Harmonium devotional chords', n: 'Harmonium' },
  { g: '🎵 South Asian — Drone & Keys', v: 'Manjira small finger cymbals rhythm', n: 'Manjira' },

  // ── PERSIAN / MIDDLE EASTERN ─────────────────────────────
  { g: '🌙 Persian / Middle Eastern', v: 'Oud Arabic lute melody', n: 'Oud' },
  { g: '🌙 Persian / Middle Eastern', v: 'Kanun plucked zither melody', n: 'Kanun / Qanun' },
  { g: '🌙 Persian / Middle Eastern', v: 'Tar Iranian long-necked lute', n: 'Tar (Iranian)' },
  { g: '🌙 Persian / Middle Eastern', v: 'Setar Persian three-string lute', n: 'Setar' },
  { g: '🌙 Persian / Middle Eastern', v: 'Santur Persian hammered dulcimer', n: 'Santur (Persian)' },
  { g: '🌙 Persian / Middle Eastern', v: 'Kamancheh Persian bowed string', n: 'Kamancheh' },
  { g: '🌙 Persian / Middle Eastern', v: 'Ney Persian end-blown flute', n: 'Ney (Persian)' },
  { g: '🌙 Persian / Middle Eastern', v: 'Darbuka goblet drum rhythm', n: 'Darbuka' },
  { g: '🌙 Persian / Middle Eastern', v: 'Tombak Persian goblet drum', n: 'Tombak / Zarb' },
  { g: '🌙 Persian / Middle Eastern', v: 'Duduk Armenian wind instrument', n: 'Duduk' },
  { g: '🌙 Persian / Middle Eastern', v: 'Zurna double-reed wind instrument', n: 'Zurna' },
  { g: '🌙 Persian / Middle Eastern', v: 'Tanbur long-necked lute melody', n: 'Tanbur' },
  { g: '🌙 Persian / Middle Eastern', v: 'Rebab Persian spike fiddle', n: 'Rebab' },

  // ── TURKISH ──────────────────────────────────────────────
  { g: '🕌 Turkish', v: 'Saz / Baglama Turkish long-necked lute', n: 'Saz / Baglama' },
  { g: '🕌 Turkish', v: 'Kemence Black Sea fiddle', n: 'Kemence' },
  { g: '🕌 Turkish', v: 'Ney Turkish end-blown flute', n: 'Ney (Turkish)' },
  { g: '🕌 Turkish', v: 'Davul large Turkish drum', n: 'Davul' },

  // ── SUFI ─────────────────────────────────────────────────
  { g: '✨ Sufi', v: 'Rubab Sufi plucked string melody', n: 'Rubab' },
  { g: '✨ Sufi', v: 'Chimta iron tongs ceremonial rhythm', n: 'Chimta' },
  { g: '✨ Sufi', v: 'Dhad small double-headed drum', n: 'Dhad' },
  { g: '✨ Sufi', v: 'Duff frame drum Sufi rhythm', n: 'Duff' },
  { g: '✨ Sufi', v: 'Algerian Gasba reed flute', n: 'Gasba' },

  // ── EAST ASIAN ───────────────────────────────────────────
  { g: '🎋 East Asian', v: 'Guzheng Chinese zither melodic phrases', n: 'Guzheng' },
  { g: '🎋 East Asian', v: 'Pipa Chinese lute melody', n: 'Pipa' },
  { g: '🎋 East Asian', v: 'Guqin ancient Chinese zither', n: 'Guqin' },
  { g: '🎋 East Asian', v: 'Erhu Chinese bowed string melody', n: 'Erhu' },
  { g: '🎋 East Asian', v: 'Dizi Chinese transverse flute', n: 'Dizi' },
  { g: '🎋 East Asian', v: 'Xiao Chinese vertical flute', n: 'Xiao' },
  { g: '🎋 East Asian', v: 'Sheng Chinese mouth organ', n: 'Sheng' },
  { g: '🎋 East Asian', v: 'Hulusi Chinese gourd flute', n: 'Hulusi' },
  { g: '🎋 East Asian', v: 'Erxian Cantonese two-string fiddle', n: 'Erxian' },
  { g: '🎋 East Asian', v: 'Koto Japanese plucked zither', n: 'Koto' },
  { g: '🎋 East Asian', v: 'Shakuhachi Japanese bamboo flute', n: 'Shakuhachi' },
  { g: '🎋 East Asian', v: 'Tsugaru Shamisen Japanese three-string lute', n: 'Shamisen' },
  { g: '🎋 East Asian', v: 'Biwa Japanese lute', n: 'Biwa' },
  { g: '🎋 East Asian', v: 'Taishogoto Japanese zither', n: 'Taishogoto' },
  { g: '🎋 East Asian', v: 'Gayageum Korean zither melody', n: 'Gayageum' },
  { g: '🎋 East Asian', v: 'Haegeum Korean bowed string', n: 'Haegeum' },
  { g: '🎋 East Asian', v: 'Daegeum Korean transverse flute', n: 'Daegeum' },
  { g: '🎋 East Asian', v: 'Geomungo Korean plucked zither', n: 'Geomungo' },
  { g: '🎋 East Asian', v: 'Taiko drums powerful Japanese ensemble', n: 'Taiko' },
  { g: '🎋 East Asian', v: 'Tsuzumi Japanese hourglass drum', n: 'Tsuzumi' },
  { g: '🎋 East Asian', v: 'Erhu and Zhongruan Chinese ensemble', n: 'Chinese Ensemble' },

  // ── SOUTH EAST ASIAN ─────────────────────────────────────
  { g: '🌴 South East Asian', v: 'Gamelan Gangsa bronze metallophones', n: 'Gamelan Gangsa' },
  { g: '🌴 South East Asian', v: 'Gamelan Gong Ageng large ceremonial gong', n: 'Gamelan Gong' },
  { g: '🌴 South East Asian', v: 'Gamelan Bonang bronze kettle gongs', n: 'Bonang' },
  { g: '🌴 South East Asian', v: 'Angklung Indonesian bamboo rattle melody', n: 'Angklung' },
  { g: '🌴 South East Asian', v: 'Suling Balinese bamboo flute', n: 'Suling' },
  { g: '🌴 South East Asian', v: 'Kendang Javanese double-headed drum', n: 'Kendang' },
  { g: '🌴 South East Asian', v: 'Kulintang Philippine gong chime melody', n: 'Kulintang' },
  { g: '🌴 South East Asian', v: 'Kacapi Sundanese zither', n: 'Kacapi' },
  { g: '🌴 South East Asian', v: 'Pi Thai oboe ceremonial', n: 'Pi (Thai Oboe)' },
  { g: '🌴 South East Asian', v: 'Ranat Ek Thai xylophone melody', n: 'Ranat (Thai Xylophone)' },
  { g: '🌴 South East Asian', v: 'Khim Thai hammered dulcimer', n: 'Khim' },
  { g: '🌴 South East Asian', v: 'Phin Thai three-string lute', n: 'Phin' },

  // ── CENTRAL ASIAN ────────────────────────────────────────
  { g: '🏔 Central Asian', v: 'Dutar Central Asian two-string lute', n: 'Dutar' },
  { g: '🏔 Central Asian', v: 'Dombyra Kazakh two-string lute', n: 'Dombyra' },
  { g: '🏔 Central Asian', v: 'Komuz Kyrgyz three-string lute', n: 'Komuz' },
  { g: '🏔 Central Asian', v: 'Kobyz Kazakh bowed spike fiddle', n: 'Kobyz' },
  { g: '🏔 Central Asian', v: 'Chang Central Asian hammered dulcimer', n: 'Chang' },
  { g: '🏔 Central Asian', v: 'Dotar Turkmen two-string lute', n: 'Dotar' },
  { g: '🏔 Central Asian', v: 'Morin Khuur Mongolian horse-head fiddle', n: 'Morin Khuur' },
  { g: '🏔 Central Asian', v: 'Throat singing Mongolian khoomii overtones', n: 'Throat Singing / Khoomii' },

  // ── WORLD STRINGS ────────────────────────────────────────
  { g: '🌍 World Strings', v: 'Bouzouki Greek plucked string', n: 'Bouzouki' },
  { g: '🌍 World Strings', v: 'Flamenco Guitar passionate strumming', n: 'Flamenco Guitar' },
  { g: '🌍 World Strings', v: 'Celtic Harp flowing arpeggios', n: 'Celtic Harp' },
  { g: '🌍 World Strings', v: 'Kora West African bridge harp', n: 'Kora' },
  { g: '🌍 World Strings', v: 'Charango Andean small guitar', n: 'Charango' },
  { g: '🌍 World Strings', v: 'Sitar-style electric guitar Indian fusion', n: 'Sitar-Electric Fusion' },
  { g: '🌍 World Strings', v: 'Cittern Medieval plucked string', n: 'Cittern' },
  { g: '🌍 World Strings', v: 'Mandolin Italian folk plucked melody', n: 'Mandolin' },
  { g: '🌍 World Strings', v: 'Banjo American folk plucked', n: 'Banjo' },
  { g: '🌍 World Strings', v: 'Hammered Dulcimer Appalachian folk', n: 'Hammered Dulcimer' },
  { g: '🌍 World Strings', v: 'Akonting West African lute ancestor', n: 'Akonting' },
  { g: '🌍 World Strings', v: 'Ngombi Central African harp', n: 'Ngombi' },
  { g: '🌍 World Strings', v: 'Valiha Malagasy bamboo tube zither', n: 'Valiha' },
  { g: '🌍 World Strings', v: 'Balalaika Russian triangular lute', n: 'Balalaika' },
  { g: '🌍 World Strings', v: 'Bandura Ukrainian plucked zither', n: 'Bandura' },

  // ── WESTERN CLASSICAL ────────────────────────────────────
  { g: '🎻 Western Classical', v: 'Solo cello performing deep melody', n: 'Cello' },
  { g: '🎻 Western Classical', v: 'Solo violin performing melodic lead', n: 'Violin' },
  { g: '🎻 Western Classical', v: 'Viola warm middle voice melody', n: 'Viola' },
  { g: '🎻 Western Classical', v: 'Double Bass deep pizzicato', n: 'Double Bass' },
  { g: '🎻 Western Classical', v: 'String Quartet ensemble', n: 'String Quartet' },
  { g: '🎻 Western Classical', v: 'Oboe lyrical melody', n: 'Oboe' },
  { g: '🎻 Western Classical', v: 'English Horn / Cor Anglais warm melody', n: 'English Horn' },
  { g: '🎻 Western Classical', v: 'Solo flute melodic lines', n: 'Flute' },
  { g: '🎻 Western Classical', v: 'Piccolo bright high melody', n: 'Piccolo' },
  { g: '🎻 Western Classical', v: 'Alto Flute warm low melody', n: 'Alto Flute' },
  { g: '🎻 Western Classical', v: 'Clarinet warm melodic lead', n: 'Clarinet' },
  { g: '🎻 Western Classical', v: 'Bass Clarinet deep melodic voice', n: 'Bass Clarinet' },
  { g: '🎻 Western Classical', v: 'Bassoon low melodic voice', n: 'Bassoon' },
  { g: '🎻 Western Classical', v: 'Contrabassoon deepest wind voice', n: 'Contrabassoon' },
  { g: '🎻 Western Classical', v: 'Trumpet melodic lead', n: 'Trumpet' },
  { g: '🎻 Western Classical', v: 'French Horn warm melodic phrases', n: 'French Horn' },
  { g: '🎻 Western Classical', v: 'Classical Guitar nylon string melody', n: 'Classical Guitar' },

  // ── KEYS & PIANO ─────────────────────────────────────────
  { g: '🎹 Keys & Piano', v: 'Grand Piano melodic lead', n: 'Grand Piano' },
  { g: '🎹 Keys & Piano', v: 'Prepared Piano experimental textures', n: 'Prepared Piano' },
  { g: '🎹 Keys & Piano', v: 'Rhodes electric piano chord comping', n: 'Rhodes' },
  { g: '🎹 Keys & Piano', v: 'Fender Rhodes warm electric piano', n: 'Fender Rhodes' },
  { g: '🎹 Keys & Piano', v: 'Wurlitzer electric piano warm tone', n: 'Wurlitzer' },
  { g: '🎹 Keys & Piano', v: 'Pipe Organ sustained chords', n: 'Pipe Organ' },
  { g: '🎹 Keys & Piano', v: 'Harpsichord baroque melodic lines', n: 'Harpsichord' },
  { g: '🎹 Keys & Piano', v: 'Mellotron vintage tape keyboard', n: 'Mellotron' },
  { g: '🎹 Keys & Piano', v: 'Celesta delicate bell-like keys', n: 'Celesta' },

  // ── ELECTRONIC / SYNTH ───────────────────────────────────
  { g: '🎛 Electronic / Synth', v: 'Analog Pad atmospheric synth chords', n: 'Analog Pad' },
  { g: '🎛 Electronic / Synth', v: 'Modular Synth evolving textures', n: 'Modular Synth' },
  { g: '🎛 Electronic / Synth', v: 'Ambient Drone Synth sustained texture', n: 'Ambient Drone Synth' },
  { g: '🎛 Electronic / Synth', v: 'Theremin eerie wavering melody', n: 'Theremin' },
  { g: '🎛 Electronic / Synth', v: 'Ondes Martenot French electronic melody', n: 'Ondes Martenot' },
  { g: '🎛 Electronic / Synth', v: 'Moog Synth classic analog lead', n: 'Moog Synth' },
  { g: '🎛 Electronic / Synth', v: 'Synth Lead driving melodic line', n: 'Synth Lead' },
  { g: '🎛 Electronic / Synth', v: 'Granular Synth textural glitch', n: 'Granular Synth' },

  // ── BOWLS & BELLS ────────────────────────────────────────
  { g: '🔔 Bowls & Bells', v: 'Tibetan Singing Bowls resonant tone', n: 'Singing Bowls' },
  { g: '🔔 Bowls & Bells', v: 'Crystal Bowl pure resonant tone', n: 'Crystal Bowl' },
  { g: '🔔 Bowls & Bells', v: 'Handpan melodic percussion', n: 'Handpan / Hang Drum' },
  { g: '🔔 Bowls & Bells', v: 'Marimba wooden mallet melody', n: 'Marimba' },
  { g: '🔔 Bowls & Bells', v: 'Vibraphone jazz mallet melody', n: 'Vibraphone' },
  { g: '🔔 Bowls & Bells', v: 'Steel Tongue Drum meditative melody', n: 'Steel Tongue Drum' },
  { g: '🔔 Bowls & Bells', v: 'Glass Harmonica ethereal bowl melody', n: 'Glass Harmonica' },
  { g: '🔔 Bowls & Bells', v: 'Cristal Baschet experimental glass rods', n: 'Cristal Baschet' },

  // ── AFRICAN ──────────────────────────────────────────────
  { g: '🌍 African', v: 'Balafon West African xylophone', n: 'Balafon' },
  { g: '🌍 African', v: 'Talking Drum variable pitch drum', n: 'Talking Drum' },
  { g: '🌍 African', v: 'Shekere beaded gourd shaker', n: 'Shekere' },
  { g: '🌍 African', v: 'Mbira African thumb piano', n: 'Mbira' },
  { g: '🌍 African', v: 'Ngoni West African lute', n: 'Ngoni' },
  { g: '🌍 African', v: 'Sabar Senegalese drum', n: 'Sabar' },
  { g: '🌍 African', v: 'Ogene Bell Igbo iron bell', n: 'Ogene Bell' },
  { g: '🌍 African', v: 'Udu Clay drum West African', n: 'Udu Drum' },
  { g: '🌍 African', v: 'Djembe West African hand drum', n: 'Djembe' },
  { g: '🌍 African', v: 'Kora West African bridge harp 21-string', n: 'Kora' },
  { g: '🌍 African', v: 'Akonting Gambian folk lute ancestor of banjo', n: 'Akonting' },
  { g: '🌍 African', v: 'Seperewa Ghanaian harp-lute', n: 'Seperewa' },
  { g: '🌍 African', v: 'Hosho Zimbabwean gourd rattle', n: 'Hosho' },
  { g: '🌍 African', v: 'Kalimba thumb piano gentle melody', n: 'Kalimba' },

  // ── CELTIC / NORDIC ──────────────────────────────────────
  { g: '🍀 Celtic / Nordic', v: 'Uilleann Pipes Irish bagpipes', n: 'Uilleann Pipes' },
  { g: '🍀 Celtic / Nordic', v: 'Irish Fiddle Celtic folk melody', n: 'Irish Fiddle' },
  { g: '🍀 Celtic / Nordic', v: 'Tin Whistle bright folk melody', n: 'Tin Whistle' },
  { g: '🍀 Celtic / Nordic', v: 'Bodhran Irish frame drum rhythm', n: 'Bodhran' },
  { g: '🍀 Celtic / Nordic', v: 'Hurdy-Gurdy medieval drone melody', n: 'Hurdy-Gurdy' },
  { g: '🍀 Celtic / Nordic', v: 'Hardanger Fiddle Norwegian folk violin', n: 'Hardanger Fiddle' },
  { g: '🍀 Celtic / Nordic', v: 'Nordic Flute Scandinavian folk flute', n: 'Nordic Flute' },
  { g: '🍀 Celtic / Nordic', v: 'Nyckelharpa Swedish keyed fiddle', n: 'Nyckelharpa' },
  { g: '🍀 Celtic / Nordic', v: 'Lur ancient Scandinavian bronze horn', n: 'Lur' },
  { g: '🍀 Celtic / Nordic', v: 'Scottish Bagpipes highland drone melody', n: 'Scottish Bagpipes' },

  // ── JAZZ & BLUES ─────────────────────────────────────────
  { g: '🎷 Jazz & Blues', v: 'Alto Saxophone jazz lead melody', n: 'Alto Saxophone' },
  { g: '🎷 Jazz & Blues', v: 'Tenor Saxophone warm jazz melody', n: 'Tenor Saxophone' },
  { g: '🎷 Jazz & Blues', v: 'Soprano Saxophone bright jazz lead', n: 'Soprano Saxophone' },
  { g: '🎷 Jazz & Blues', v: 'Baritone Saxophone deep jazz lead', n: 'Baritone Saxophone' },
  { g: '🎷 Jazz & Blues', v: 'Muted Trumpet cool jazz lead', n: 'Muted Trumpet' },
  { g: '🎷 Jazz & Blues', v: 'Flugelhorn warm mellow jazz trumpet', n: 'Flugelhorn' },
  { g: '🎷 Jazz & Blues', v: 'Trombone smooth jazz melody', n: 'Trombone' },
  { g: '🎷 Jazz & Blues', v: 'Hammond Organ soulful chords', n: 'Hammond Organ' },
  { g: '🎷 Jazz & Blues', v: 'Harmonica blues lead melody', n: 'Harmonica' },
  { g: '🎷 Jazz & Blues', v: 'Jazz Drums swinging groove', n: 'Jazz Drums' },
  { g: '🎷 Jazz & Blues', v: 'Lap Steel Guitar slide blues melody', n: 'Lap Steel Guitar' },
  { g: '🎷 Jazz & Blues', v: 'Pedal Steel Guitar country slide melody', n: 'Pedal Steel Guitar' },
  { g: '🎷 Jazz & Blues', v: 'Dobro resonator guitar blues slide', n: 'Dobro / Resonator' },

  // ── LATIN / CARIBBEAN ────────────────────────────────────
  { g: '🌴 Latin / Caribbean', v: 'Latin Trumpet bright salsa lead', n: 'Latin Trumpet' },
  { g: '🌴 Latin / Caribbean', v: 'Congas Afro-Latin hand drums', n: 'Congas' },
  { g: '🌴 Latin / Caribbean', v: 'Bongos Afro-Cuban percussion', n: 'Bongos' },
  { g: '🌴 Latin / Caribbean', v: 'Timbales Latin percussion', n: 'Timbales' },
  { g: '🌴 Latin / Caribbean', v: 'Bandoneon Argentine tango accordion', n: 'Bandoneon' },
  { g: '🌴 Latin / Caribbean', v: 'Steel Pan Caribbean melodic percussion', n: 'Steel Pan' },
  { g: '🌴 Latin / Caribbean', v: 'Tres Guitar Cuban tres guitar', n: 'Tres Guitar' },
  { g: '🌴 Latin / Caribbean', v: 'Cuatro Venezuelan four-string guitar', n: 'Cuatro' },
  { g: '🌴 Latin / Caribbean', v: 'Berimbau Brazilian bow instrument', n: 'Berimbau' },
  { g: '🌴 Latin / Caribbean', v: 'Pandeiro Brazilian frame drum', n: 'Pandeiro' },
  { g: '🌴 Latin / Caribbean', v: 'Zabumba Brazilian bass drum', n: 'Zabumba' },
  { g: '🌴 Latin / Caribbean', v: 'Accordion Tejano border music', n: 'Accordion' },

  // ── WESTERN / POP / ROCK ─────────────────────────────────
  { g: '🎸 Western / Pop', v: 'Electric Guitar clean melodic lead', n: 'Electric Guitar' },
  { g: '🎸 Western / Pop', v: 'Distorted Guitar heavy riff', n: 'Distorted Guitar' },
  { g: '🎸 Western / Pop', v: 'Acoustic Guitar fingerpicked arpeggios', n: 'Acoustic Guitar' },
  { g: '🎸 Western / Pop', v: 'Bass Guitar groovy low end', n: 'Bass Guitar' },
  { g: '🎸 Western / Pop', v: 'Drum Kit full acoustic groove', n: 'Drum Kit' },
  { g: '🎸 Western / Pop', v: 'Upright Bass warm plucked bass', n: 'Upright Bass' },
  { g: '🎸 Western / Pop', v: 'Chapman Stick two-handed tapping', n: 'Chapman Stick' },

  // ── ORCHESTRAL ───────────────────────────────────────────
  { g: '🎼 Orchestral', v: 'String Orchestra sweeping ensemble', n: 'String Orchestra' },
  { g: '🎼 Orchestral', v: 'Choir vocal ensemble sustained', n: 'Choir' },
  { g: '🎼 Orchestral', v: 'Horn Section brass ensemble stabs', n: 'Horn Section' },
  { g: '🎼 Orchestral', v: 'Timpani orchestral kettle drums', n: 'Timpani' },
  { g: '🎼 Orchestral', v: 'Cinematic Drums powerful hits', n: 'Cinematic Drums' },
  { g: '🎼 Orchestral', v: 'Brass Ensemble full brass section', n: 'Brass Ensemble' },
  { g: '🎼 Orchestral', v: 'Harp orchestral glissando arpeggios', n: 'Harp' },
  { g: '🎼 Orchestral', v: 'Flute Section orchestral wind ensemble', n: 'Flute Section' },
  { g: '🎼 Orchestral', v: 'Lyre ancient plucked string melody', n: 'Lyre' },
  { g: '🎼 Orchestral', v: 'Lute Renaissance plucked melody', n: 'Lute' },

  // ── ELECTRONIC / LO-FI ───────────────────────────────────
  { g: '💿 Electronic / Lo-Fi', v: 'Lo-Fi Drums dusty sampled drums', n: 'Lo-Fi Drums' },
  { g: '💿 Electronic / Lo-Fi', v: 'Tape Piano warped vintage piano', n: 'Tape Piano' },
  { g: '💿 Electronic / Lo-Fi', v: '808 Bass deep sub bass hit', n: '808 Bass' },

  // ── OTHER / AMBIENT ──────────────────────────────────────
  { g: '🎵 Other / Ambient', v: 'Didgeridoo Aboriginal drone instrument', n: 'Didgeridoo' },
  { g: '🎵 Other / Ambient', v: 'Wind Chimes ambient texture', n: 'Wind Chimes' },
  { g: '🎵 Other / Ambient', v: 'Vinyl/Rain Texture lo-fi atmosphere', n: 'Vinyl/Rain Texture' },
  { g: '🎵 Other / Ambient', v: 'Musical Saw eerie bowed melody', n: 'Musical Saw' },
  { g: '🎵 Other / Ambient', v: 'Waterphone experimental resonant metal', n: 'Waterphone' },
];

export const ATMOSPHERES = [
  { label: '🏛 Indian Classical', options: [
    { v: 'Hindustani Classical', l: 'Hindustani Classical' },
    { v: 'Carnatic Classical', l: 'Carnatic Classical' },
    { v: 'Indian Classical Fusion', l: 'Indian Classical Fusion' },
    { v: 'Sufi', l: 'Sufi' },
    { v: 'Devotional / Bhajan', l: 'Devotional / Bhajan' },
    { v: 'Qawwali', l: 'Qawwali' },
  ]},
  { label: '🌊 Ambient', options: [
    { v: 'Ambient', l: 'Ambient' },
    { v: 'Dark Ambient', l: 'Dark Ambient' },
    { v: 'Drone', l: 'Drone' },
    { v: 'Space Ambient', l: 'Space Ambient' },
    { v: 'Healing / Therapeutic', l: 'Healing / Therapeutic' },
    { v: 'Meditation', l: 'Meditation' },
    { v: 'New Age', l: 'New Age' },
  ]},
  { label: '🎧 Electronic', options: [
    { v: 'Lo-Fi Hip Hop', l: 'Lo-Fi Hip Hop' },
    { v: 'Chillhop', l: 'Chillhop' },
    { v: 'Electronic', l: 'Electronic' },
    { v: 'Deep House', l: 'Deep House' },
    { v: 'Synthwave', l: 'Synthwave' },
    { v: 'Trap', l: 'Trap' },
    { v: 'IDM / Intelligent Dance Music', l: 'IDM / Intelligent Dance' },
  ]},
  { label: '🎬 Cinematic', options: [
    { v: 'Cinematic Orchestral', l: 'Cinematic Orchestral' },
    { v: 'Epic Cinematic', l: 'Epic Cinematic' },
    { v: 'Indian Cinematic', l: 'Indian Cinematic' },
    { v: 'Dark Cinematic', l: 'Dark Cinematic' },
    { v: 'Minimalist Cinematic', l: 'Minimalist Cinematic' },
  ]},
  { label: '🌍 World', options: [
    { v: 'Persian Classical', l: 'Persian Classical' },
    { v: 'Arabic Maqam', l: 'Arabic Maqam' },
    { v: 'Turkish Classical', l: 'Turkish Classical' },
    { v: 'Flamenco', l: 'Flamenco' },
    { v: 'Celtic / Folk', l: 'Celtic / Folk' },
    { v: 'Klezmer', l: 'Klezmer' },
    { v: 'Afrobeat', l: 'Afrobeat' },
    { v: 'Bossa Nova', l: 'Bossa Nova' },
    { v: 'Tango', l: 'Tango' },
    { v: 'Gamelan', l: 'Gamelan (Indonesian)' },
    { v: 'World Music', l: 'World Music (General)' },
  ]},
  { label: '🎸 Contemporary', options: [
    { v: 'Jazz', l: 'Jazz' },
    { v: 'Fusion Jazz', l: 'Fusion Jazz' },
    { v: 'Neo Soul', l: 'Neo Soul' },
    { v: 'Folk', l: 'Folk' },
    { v: 'Classical', l: 'Classical' },
    { v: 'Blues', l: 'Blues' },
  ]},
];

export const BRAINWAVES = [
  { v: '', l: '— None / Not applicable —' },
  { v: 'delta binaural 2Hz', l: 'Delta (0.5–4 Hz) — Deep sleep, healing' },
  { v: 'theta binaural 6Hz', l: 'Theta (4–8 Hz) — Deep meditation, creativity' },
  { v: 'alpha binaural 10Hz', l: 'Alpha (8–14 Hz) — Relaxed focus, calm' },
  { v: 'low beta binaural 16Hz', l: 'Low Beta (14–20 Hz) — Focused thinking' },
  { v: 'beta binaural 25Hz', l: 'Beta (20–30 Hz) — Active concentration' },
  { v: 'gamma binaural 40Hz', l: 'Gamma (30–100 Hz) — Peak performance' },
];

export const FREQS = [
  { v: '', l: '— Standard tuning —' },
  { v: '432Hz tuning', l: '432 Hz — Natural, warm tuning' },
  { v: '528Hz solfeggio', l: '528 Hz — DNA repair, transformation' },
  { v: '396Hz solfeggio', l: '396 Hz — Release guilt and fear' },
  { v: '417Hz solfeggio', l: '417 Hz — Facilitate change' },
  { v: '639Hz solfeggio', l: '639 Hz — Relationships, harmony' },
  { v: '741Hz solfeggio', l: '741 Hz — Awakening intuition' },
  { v: '852Hz solfeggio', l: '852 Hz — Return to spiritual order' },
  { v: '963Hz solfeggio', l: '963 Hz — Crown chakra, divine connection' },
];
